import { render, staticRenderFns } from "./AuthLocale.vue?vue&type=template&id=6a69b5e6&scoped=true"
import script from "./AuthLocale.vue?vue&type=script&lang=js"
export * from "./AuthLocale.vue?vue&type=script&lang=js"
import style0 from "./AuthLocale.vue?vue&type=style&index=0&id=6a69b5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69b5e6",
  null
  
)

export default component.exports